module.exports = __webpack_public_path__ + "static/media/33-4.acaf676c.mp3";